import React from 'react';
import { Box } from '@mui/material';
import { DiffLine } from '../../../models/admin';

interface VeraPromptDiffViewProps {
  diff: DiffLine[];
  maxLines?: number;
}

export default function VeraPromptDiffView({ diff, maxLines = 120 }: VeraPromptDiffViewProps) {
  const visible = diff.slice(0, maxLines);
  return (
    <Box
      component="table"
      sx={{
        width: '100%',
        borderCollapse: 'collapse',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        overflow: 'hidden',
        fontFamily: 'monospace',
        fontSize: '0.75rem',
      }}
    >
      <tbody>
        {visible.map((line, i) => (
          <Box
            component="tr"
            key={i}
            sx={{
              bgcolor:
                line.type === 'added'
                  ? '#e6ffed'
                  : line.type === 'removed'
                    ? '#ffebe9'
                    : 'transparent',
            }}
          >
            <Box
              component="td"
              sx={{
                px: 1,
                py: '1px',
                color:
                  line.type === 'added'
                    ? 'success.dark'
                    : line.type === 'removed'
                      ? 'error.dark'
                      : 'text.disabled',
                borderRight: '1px solid',
                borderColor: 'divider',
                userSelect: 'none',
                whiteSpace: 'pre',
                width: '1em',
              }}
            >
              {line.type === 'added' ? '+' : line.type === 'removed' ? '-' : ' '}
            </Box>
            <Box
              component="td"
              sx={{ px: 1, py: '1px', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}
            >
              {line.text}
            </Box>
          </Box>
        ))}
        {diff.length > maxLines && (
          <Box component="tr">
            <Box
              component="td"
              colSpan={2}
              sx={{
                px: 1,
                py: 0.5,
                color: 'text.secondary',
                fontStyle: 'italic',
                fontSize: '0.7rem',
              }}
            >
              … {diff.length - maxLines} more lines
            </Box>
          </Box>
        )}
      </tbody>
    </Box>
  );
}
